<template>
  <div 
    class="moveImgWrap" 
    @mousemove="mouseMove" 
    @mouseleave="mouseLeave" 
    ref="moveImgWrap"
  >
    <img :src="imgSrc" class="moveImg" :style="`transform: translate(${x}px, ${y}px)`"/>
  </div>
</template>

<script>

export default {
  name: 'moveImg',
  props: {
    imgSrc: {
      type: String,
      default: '',
    }
  },
  data () {
    return {
      x: 0,
      y: 0,
      width: 0,
      height: 0,
    }
  },

  mounted () {
    let info = this.$refs.moveImgWrap.getBoundingClientRect()
    let { width, height } = info
    this.width = width
    this.height = height
  },

  methods: {
    mouseMove (e) {
      let { offsetX, offsetY } = e
      let { width, height } = this
      this.x = (width / 2 - offsetX) / 10
      this.y = (height / 2 - offsetY) / 10
    },
    mouseLeave () {
      this.x = 0
      this.y = 0
    }
  },
}
</script>

<style lang="stylus" scoped>
.moveImgWrap {
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  .moveImg {
    width: 110%;
    height: 110%;
    object-fit: cover;
    transform-origin: center center;
    transition: .05s;
  }
}
</style>